const mixinFilters = {
  methods: {
    //美元格式化
    dollorStyle(num) {
      if (typeof num == 'undefined' || isNaN(num)) {
        num = 0;
      }
      var result = this.toFixed(num, 2);
      result = "$" + this.comdify(result);
      return result;
    },
    //毫秒转成小时，分钟，秒
    //时间戳转换
    getUtcTime(timestamp, format) {
      var d = new Date(timestamp),
        formatch = format || "dot",
        charDate;
      if (formatch == "tomorrow") {
        d.setDate(d.getDate() + 1);
      }
      //根据date对象获取详细时间
      var year = parseInt(d.getUTCFullYear()),
        month = parseInt(d.getUTCMonth() + 1),
        dates = parseInt(d.getUTCDate()),
        hours = parseInt(d.getUTCHours()),
        minutes = parseInt(d.getUTCMinutes()),
        week = parseInt(d.getUTCDay());
      //小于10的数字前面加0
      if (month < 10) month = "0" + month;
      if (dates < 10) dates = "0" + dates;
      if (hours < 10) hours = "0" + hours;
      if (minutes < 10) minutes = "0" + minutes;
      //输入需要的时间格式
      if (formatch == "dot") { //以"."为分隔符，默认此项 2016.9.21 12:00
        charDate = year + "-" + month + "-" + dates;
      }
      return charDate;
    },
    today() {
      return this.getUtcTime(new Date().getTime());
    },
    yesterday() {
      return this.getUtcTime(new Date().getTime() - 3600 * 1000 * 24);
    },
    week() {
      return this.getUtcTime(new Date().getTime() - 3600 * 1000 * 24 * 7);
    },
    mouth() {
      return this.getUtcTime(new Date().getTime() - 3600 * 1000 * 24 * 30);
    },
    //明年
    nextYear() {
      return this.getUtcTime(new Date().getTime() + 3600 * 1000 * 24 * 365);
    },
    //下N年
    nextNumYear(n = 1) {
      return this.getUtcTime(new Date().getTime() + 3600 * 1000 * 24 * 365 * n);
    },
  }
}
export default mixinFilters



// WEBPACK FOOTER //
// ./src/mixins/filters.js